package org.example.project.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.dashboard.DashboardNode
import org.example.project.dashboard.ScreenManager
import org.example.project.dashboard.TrackedScreenHost
import org.example.project.engineslot.SlotStyles
import org.example.project.service.RollenService
import org.example.project.service.LizenzService
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.example.project.settings.AppDropdown
import org.example.project.settings.AppDropdownAppearance
import org.example.project.settings.AppDropdownMenuMode
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Style
import org.jetbrains.compose.web.dom.Text

@Composable
fun CusBereichWrapper(
    screenKey: String,
    settingsKeys: Set<String> = emptySet(),
    excludedKeys: Set<String> = emptySet(),
    settingsLabel: String = "Einstellungen",
    buttonLabels: Map<String, String> = emptyMap(),
    node: String = DashboardNode.CUS
) {
    val usesCusLizenz = node == DashboardNode.CUS || node == DashboardNode.CUS_MOBILE
    val screens = ScreenManager.childScreensForKey(screenKey, node)
        .filter {
            it.key !in excludedKeys &&
                (!usesCusLizenz || it.key in LizenzService.getEffectiveScreens()) &&
                (node == DashboardNode.NET || RollenService.hasReadPermission(it.key))
        }
    val mainScreens = screens.filter { it.key !in settingsKeys }
    val settingsScreens = screens.filter { it.key in settingsKeys }
    var selectedKey by remember(screenKey, node) { mutableStateOf("") }
    val selected = screens.firstOrNull { it.key == selectedKey }
        ?: mainScreens.firstOrNull()
        ?: settingsScreens.firstOrNull()
    Style(SlotStyles)
    Div({ classes(SlotStyles.screenRoot) }) {
        Div({
            style {
                width(100.percent)
                minWidth(0.px)
                boxSizing("border-box")
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                gap(12.px)
                flexWrap(FlexWrap.Wrap)
                padding(6.px, 16.px, 0.px, 16.px)
                minHeight(34.px)
                flexShrink(0)
            }
        }) {
            Div({ style {
                display(DisplayStyle.Flex)
                flex("1 1 auto")
                minWidth(0.px)
                maxWidth(100.percent)
                justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center)
                flexWrap(FlexWrap.Wrap)
                gap(12.px)
            } }) {
                mainScreens.forEach { screen ->
                    LumaticaButton(
                        label = buttonLabels[screen.key] ?: screen.label.removePrefix("Palettenkonto "),
                        onClick = { selectedKey = screen.key },
                        variant = LumaticaButtonVariant.State,
                        isActive = selected?.key == screen.key
                    )
                }
            }
            if (settingsScreens.isNotEmpty()) {
                Div({ style {
                    position(Position.Relative)
                    width(200.px)
                    maxWidth(100.percent)
                    flexShrink(0)
                    property("margin-left", "auto")
                } }) {
                    AppDropdown(
                        options = settingsScreens.map { All(key = it.key, label = it.label) },
                        selectedValue = null,
                        onChange = { selectedKey = it },
                        placeholder = settingsScreens.firstOrNull { it.key == selected?.key }?.label ?: settingsLabel,
                        appearance = AppDropdownAppearance.Field,
                        menuMode = AppDropdownMenuMode.Overlay,
                        attrs = { style { paddingLeft(24.px); boxSizing("border-box") } }
                    )
                    Img(src = "images/einstellungen.svg", attrs = {
                        attr("alt", "")
                        style {
                            position(Position.Absolute)
                            left(8.px)
                            top(50.percent)
                            width(20.px)
                            height(20.px)
                            property("transform", "translateY(-50%)")
                            property("pointer-events", "none")
                        }
                    })
                }
            }
        }
        Div({
            style {
                width(100.percent)
                height(1.px)
                backgroundColor(Color("rgba(255,255,255,0.14)"))
                flexShrink(0)
            }
        })
        Div({
            style {
                flex("1")
                minHeight(0.px)
                overflowY("auto")
            }
        }) {
            if (selected == null) {
                Text("Keine freigegebenen Bereiche vorhanden.")
            } else {
                key(selected.key) {
                    TrackedScreenHost(selected) { selected.content?.invoke(selected) }
                }
            }
        }
    }
}
